export default "__VITE_ASSET__DtPAOLK___"